import { OrderAPI } from "@app/services/api";
import { RootState } from "@app/store";
import { setEventNeedUpdate, setOrderEvents } from "@app/store/order.slice";
import { formatDate } from "@app/utils/date";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CircleSpan,
  DetailsWarper,
  StyledStatus,
  StyledTime,
  StyledDescription,
  EventWarper,
  EventLine,
} from "./eventsBox.styles";

type EventBoxProps = {
  title: string;
  description: string;
  createdAt: number;
};

type EventsBoxProps = {
  events: { title: string; description: string; createdAt: number }[];
};

export const EventBox = ({ title, description, createdAt }: EventBoxProps) => {

  const dateFormat = useSelector((state: RootState) => state.setting.dateFormat);
  const timeFormat = useSelector((state: RootState) => state.setting.timeFormat);

  const time = formatDate(createdAt , dateFormat , timeFormat);

  return (
    <>
      <EventUpdater/>
      <CircleSpan />
      <DetailsWarper>
        <StyledStatus>
          {title}
          <StyledTime> {time} </StyledTime>
        </StyledStatus>
        <StyledDescription>{description}</StyledDescription>
      </DetailsWarper>
    </>
  );
};

export const EventsBox = ({ events }: EventsBoxProps) => {
  
  const dateFormat = useSelector((state: RootState) => state.setting.dateFormat);
  const timeFormat = useSelector((state: RootState) => state.setting.timeFormat);
  const iconLightStart  = useSelector((state: RootState) => state.setting.colors.iconLightStart );
  const iconDarkStart  = useSelector((state: RootState) => state.setting.colors.iconDarkStart );
  
  return (
    <>
    <EventUpdater/>
      {events.map((e , idx) => {
        

        const time = formatDate(e.createdAt , dateFormat , timeFormat);

        const isLastOne = events.length === idx + 1
        return (
          <EventWarper key={e.createdAt}>
            {isLastOne ? null : <EventLine color={iconDarkStart} />}
            <CircleSpan color={iconLightStart} />
            <DetailsWarper>
              <StyledStatus>
                {e.title}
                <StyledTime> {time} </StyledTime>
              </StyledStatus>
              <StyledDescription>{e.description}</StyledDescription>
            </DetailsWarper>
          </EventWarper>
        );
      })}
    </>
  );
};

export const EventUpdater = () => {
  
  const isEventNeedUpdate = useSelector((state: RootState) => state.order.isEventNeedUpdate);
  const accessToken = useSelector((state: RootState) => state.customer.accessToken);
  const customerId = useSelector((state: RootState) => state.customer.customerId);
  const language = useSelector((state: RootState) => state.setting.language);
  const orderId = useSelector((state: RootState) => state.order.orderId);
  const restServerUrl = useSelector((state: RootState) => state.setting.restServerUrl);

  const dispatch = useDispatch();

  const updateEvents = ()=>{

    new OrderAPI().getEvents({
        customerId: customerId,
        language: language,
        orderId: orderId,
        restUrl: restServerUrl,
        accessToken: accessToken
      }).then(response =>{

        dispatch(setOrderEvents(response.data));
        dispatch(setEventNeedUpdate(false));
        
      }).catch(error=>{
        console.log('in error get events ');
        console.log(error);
      });

  }

  useEffect(() => {

    console.log({isEventNeedUpdate});
    if(isEventNeedUpdate){
      updateEvents();
    }

  },[isEventNeedUpdate])

  return (
    null
  );
};

